import React from "react";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import { MdArrowDropUp, MdArrowDropDown } from "react-icons/md";
import { growHeight } from "theme/Animations";
import { MenuItem } from "features/header/types";
import { useLocation, useNavigate } from "react-router-dom";

interface DrawerNavProps {
  item: any;
  containerRef: React.RefObject<HTMLDivElement>;
}

const DrawerNav: React.FC<DrawerNavProps> = ({ item, containerRef }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const onPress = () => {
    navigate(item.route);
    containerRef.current!.scrollTo(0, 0);
  };
  const isActive = location.pathname.includes(item.route);
  return (
    <DrawerNavContainer>
      <DropDownBtn isActive={isActive} onClick={onPress}>
        <Title> {item.title}</Title>
      </DropDownBtn>
    </DrawerNavContainer>
  );
};

const DrawerNavContainer = styled.div`
  min-height: ${toRem(40)};
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  justify-content: flex-start;
  overflow-y: hidden;
`;

const DropDownBtn = styled.div<{ isActive: boolean }>`
  min-height: ${toRem(40)};

  background-color: #eeeeee;
  margin-bottom: 1px;
  font-size: ${toRem(17)};
  font-weight: 500;
  border-left-style: solid;
  border-left-color: ${(props: any) =>
    props.isActive ? colors.light_blue : "#bbbbbb"};
  border-left-width: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
`;

const Title = styled.div``;
const ExpandableSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: flex-start;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none !important;
  animation: ${growHeight} 0.3s ease-in-out;
`;
export default DrawerNav;
